import { inject, Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { ENV } from '@di-tokens';
import { Import } from '@models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ImportsService {
  ENV = inject(ENV);
  http = inject(HttpClient);
  private readonly url = `${this.ENV.remoteApi}/import`;

  getImportsRequest(): Observable<Import[]> {
    return this.http.get<Import[]>(this.url);
  }

  private getDownloadLink(id: Import['id']): string {
    return `${this.url}/${id}/download`;
  }

  downloadRequest(id: Import['id']): Observable<Blob> {
    return this.http.get(this.getDownloadLink(id), { responseType: 'blob' });
  }
}
